/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export function UserChildsTableActionsColumnFormatter(
  cellContent,
  row,
  rowIndex
) {
  return (
    <>
      <OverlayTrigger overlay={<Tooltip id="specs-edit-tooltip">View</Tooltip>}>
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() =>
            window.open(
              "/user-child/" + row._id + "/" + row.systemUserType,
              "_blank"
            )
          }
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Navigation/Sign-in.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    </>
  );
}
